// src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB5Xj-Or7DZJBbnFgLBovUgZurQWTJ7abs",
  authDomain: "temeldencom.firebaseapp.com",
  databaseURL: "https://temeldencom-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "temeldencom",
  storageBucket: "temeldencom.firebasestorage.app",
  messagingSenderId: "326634052289",
  appId: "1:326634052289:web:b6e828152d9fad6d6e1240"
};

// Firebase'i başlat
const app = initializeApp(firebaseConfig);

// Servisleri başlat
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Diğer dosyalarda kullanmak için dışa aktar
export { auth, db, storage };
